// extracted by mini-css-extract-plugin
export default {"letter":"Letter_letter__-N7DR"};